export const DEFAULT_TRANSITION_PROPS = {
  classes: {
    enter: {
      from: 'opacity-0 scale-95',
      to: 'opacity-100 scale-100',
      transition: 'transition ease-out duration-200 transform',
    },
    exit: {
      from: 'opacity-100 scale-100',
      to: 'opacity-0 scale-95',
      transition: 'transition ease-in duration-200 transform',
    },
  },
};

export const DEFAULT_TRANSITION_DURATION = {
  enter: 200,
  exit: 200,
};
